import React, {useState, useEffect} from 'react';
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";

// function BootstrapDateRangePicker({page, props}) {
const BootstrapDateRangePicker = (props) => {
    const [dates, setDatesState] = useState({
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
    });

    const [dateValue, setDateValue] = useState("This Month");

    const ranges = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        // "Last 7 Days": [moment().subtract(6, "days"), moment()],
        // "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "Last 7 Days": [moment().subtract(7, "days"), moment().subtract(1, "days")],
        "Last 30 Days": [moment().subtract(30, "days"), moment().subtract(1, "days")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
        ],
    };

    useEffect(() => {
        if(props.page === 'dashboard') {
            document.querySelectorAll('[data-range-key="Custom Range"]')[0].style.display='none';
        }
    })

    const setDatesHide = (e, { startDate, endDate }) => {
        document.getElementById('daterangePickercstm').classList.remove('active');
        let customDateValue = '';
        setDateValue("")

        setDatesState({
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
        });

        var timeDiff = new Date(endDate).getTime() - new Date(startDate).getTime();
        var diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

        if (diffDays === 0) {
            var yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            yesterday.setHours(0, 0, 0, 0);
            if (new Date(startDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
                setDateValue("Today");
                customDateValue = "Today";
            }

            if (new Date(startDate).getTime() === yesterday.getTime()) {
                setDateValue("Yesterday");
                customDateValue = "Yesterday";
            }
        }

        if (diffDays === 6) {
            // if (new Date(endDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
            if (new Date(endDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
                setDateValue("Last 7 Days");
                customDateValue = "Last 7 Days";
            }
        }

        if (diffDays === 29) {
            // if (new Date(endDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
            if (new Date(endDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
                setDateValue("Last 30 Days");
                customDateValue = "Last 30 Days";
            }
        }

        const today = new Date();
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);


        if (new Date(startDate).getTime() === thisMonthStart.getTime() && new Date(endDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
            setDateValue("This Month");
            customDateValue = "This Month";
        }

        const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

        if (new Date(startDate).getTime() === lastMonthStart.getTime() && new Date(endDate).setHours(0, 0, 0, 0) === lastMonthEnd.setHours(0, 0, 0, 0)) {
            setDateValue("Last Month");
            customDateValue = "Last Month";
            document.getElementsByClassName('date_picker_control')[0].classList.remove('long-width');
            document.getElementsByClassName('date_picker_control')[0].classList.add('short-width');
        }
        if(customDateValue.length > 0) {
            document.getElementsByClassName('date_picker_control')[0].classList.remove('long-width');
            document.getElementsByClassName('date_picker_control')[0].classList.add('short-width');
        }else {
            document.getElementsByClassName('date_picker_control')[0].classList.add('long-width');
            document.getElementsByClassName('date_picker_control')[0].classList.remove('short-width');
        }
        document.getElementById('hiddenDateRange').value=startDate.format("YYYY-MM-DD")+' - '+endDate.format("YYYY-MM-DD");
    };


    const setDates = (e, { startDate, endDate }) => {
        props.func('dateChanged');
        document.getElementById('daterangePickercstm').classList.remove('active');
    };
    const setDatePickerShow = () => {
        document.getElementById('daterangePickercstm').classList.add('active');
    }
    return (
        <div className="input-group flex-nowrap w-100 br-50px daterangePicker" id="daterangePickercstm">
            {
                (props.page === 'dashboard' || props.page === 'reports')
                ?
                <>
                    {/* <span className="input-group-text" id="addon-wrapping">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="stroke">
                        <path d="M2.06177 6.26952H13.9444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.9614 8.87313H10.9675" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.0031 8.87313H8.00928" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.03862 8.87313H5.0448" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.9614 11.4642H10.9675" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.0031 11.4642H8.00928" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.03862 11.4642H5.0448" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.6958 1.33334V3.5272" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.31033 1.33334V3.5272" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M10.8255 2.38614H5.18064C3.22285 2.38614 2 3.47676 2 5.48149V11.5146C2 13.5508 3.22285 14.6667 5.18064 14.6667H10.8193C12.7833 14.6667 14 13.5697 14 11.565V5.48149C14.0062 3.47676 12.7895 2.38614 10.8255 2.38614Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span> */}
                    <DateRangePicker
                        className=""
                        onApply={setDates}
                        onHide={setDatesHide}
                        onShow={setDatePickerShow}
                        autoClose={false}
                        initialSettings={{
                            startDate: moment().startOf("month"),
                            endDate: moment().endOf("month"),
                            ranges: ranges,
                            // alwaysShowCalendars: true,
                            maxDate: new Date(),
                        }}
                        >
                        <input type="text" value={dateValue.length > 0 ? dateValue : dates.startDate + " - " + dates.endDate} className="form_control date_picker_control border-start-0 ps-0 short-width" readOnly />
                    </DateRangePicker>
                    <input id="hiddenDateRange" type="hidden" value={dates.startDate + " - " + dates.endDate} />
                </>
                :
                <></>
            }
        </div>
    );
}

export default BootstrapDateRangePicker;